// extracted by mini-css-extract-plugin
export var button = "Header-module--button--jyLCW";
export var buttonHeaderWrapper = "Header-module--buttonHeaderWrapper--TYABU";
export var buttonOne = "Header-module--buttonOne--QqYQ8";
export var buttonTwo = "Header-module--buttonTwo--uMR6t";
export var changeContentIcon = "Header-module--changeContentIcon--VeNMQ";
export var changeContentText = "Header-module--changeContentText--xFJgv";
export var header = "Header-module--header--Wcvsx";
export var headerLogoCenter = "Header-module--headerLogoCenter--0bBtX";
export var logo = "Header-module--logo--vXfki";
export var signInBtnWrapper = "Header-module--signInBtnWrapper--aQ6uh";